import React, { useState } from 'react';
import BlogLink from '../../BlogLink';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';
import ListTable from './ListTable';



function CaravanBody() {


  // 変更する
  // ---------------------------------------------
  // 2023.3.22
  // 1040,31200(sum,cost)

  const getRate = [0.0057692307692307696, 0.008653846153846154, 0.04038461538461539, 0.2230769230769231, 0.2778846153846154, 0.4442307692307692]; //獲得確率

  const medalPerEngrgy = 57.5452302631579; //メダル/1エナジー

  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------
  const needMedal = 30;
  const itemPertimes = [1, 1, 1, 1, 100, 100];
  const timesPerEngrgy = medalPerEngrgy / needMedal; //1エナジーあたり何回抽選できるか

  // ---------------------------------------------

  //   集計
  const getRatePerEnergy = [];
  for (let i = 0; i < getRate.length; i++) {
    getRatePerEnergy[i] = getRate[i] * timesPerEngrgy //1エナジーあたりi等が何回当たるか
  }

  const [digits, setDigits] = useState(0);
  const [energy, setEnergy] = useState(250);

  //   実質消費エナジー
  const returnRate = getRatePerEnergy[3] * itemPertimes[3]
  const realEnergy = 1 - returnRate;

  //   消費エナジー変更
  const handleEnergyChange = (event) => {
    setEnergy(event.target.value);
  };

  //   桁数変更
  const handleDigitsChange = (event) => {
    if (event.target.value >= 0) {
      var dig = event.target.value;
    } else {
      var dig = 0;
    }
    setDigits(dig);
  };


  const calculateItem = () => {
    const getItemPerRealEnergy = [];
    const getItemExpected = [];
    for (let i = 0; i < getRate.length; i++) {
      // getItemPerRealEnergy[i] = getItem[i] / realEnergy;
      getItemPerRealEnergy[i] = getRatePerEnergy[i] / realEnergy; //後で修正

      getItemExpected[i] = ((getItemPerRealEnergy[i] * energy) * itemPertimes[i]).toFixed(digits);
    }
    console.log(getItemPerRealEnergy)

    return getItemExpected
  }


  const getItemExpected = calculateItem()

  const itemExpectedList = [
    { name: 'S30%契約書', result: getItemExpected[0] },
    { name: 'A契約書', result: getItemExpected[1] },
    { name: 'B契約書', result: getItemExpected[2] },
    { name: 'スカウトP', result: getItemExpected[4] },
    { name: 'コイン', result: getItemExpected[5] },
  ];

  return (
    <>
      <Base body={
        <Container>
          <h1>ドリームキャラバン</h1>
          <Label>
            <Text>消費エナジー：</Text>
            <Input type="number" value={energy} onChange={handleEnergyChange} />
          </Label>

          < div >
            <h2>計算結果</h2>
            <ListTable list={itemExpectedList} />
          </div >
          <Result>
            <Text>エナジー還元率:{returnRate.toFixed(3)}</Text>
          </Result>
          <div>
            <p>{energy}エナジー消費した時に得られるアイテム数の期待値がResultに表示されます。</p>
          </div>
          <BlogLink link={"https://www.sakusaku27.com/18/"} />
        </Container>

      } title="キャラバン" />
    </>
  );
}

export default CaravanBody;
